import {parse} from 'qs';
import Url from 'url-parse';
import {PagewebUrl} from '../scheme/PagewebUrl.class';
import {PolicyType} from './PolicyType.enum';

export function getV1RedirectPagewebUrl({
  v1Url,
  linkOrigin,
  _origin,
}: {
  v1Url: string;
  linkOrigin: string;
  _origin?: string;
}): PagewebUrl | undefined {
  const {pathname: _pathname, query: _query} = new Url(v1Url);

  const pathname = _pathname.replace(/(^\/|\/$)/g, '');
  const splittedPathList = pathname.split('/');
  const querystring = _query.replace(/^\?/g, '');
  const parsedQueryparam = parse(querystring);

  let origin = _origin;
  let path;
  let queryparam;

  const firstPath = splittedPathList[0];
  switch (firstPath) {
    case 'policy':
      {
        const {
          type: policyTypeV1,
          noticeId,
          noticePage,
          ...rest
        } = parsedQueryparam;
        if (!policyTypeV1) {
          return;
        }

        if (policyTypeV1 === 'notice') {
          if (noticeId) {
            path = `/notice/${noticeId}`;
            queryparam = rest;
          } else {
            path = '/notice';
            queryparam = {
              ...rest,
              ...(noticePage && {notice_page: noticePage}),
            };
          }
        } else {
          let policyType;
          if (policyTypeV1 === 'terms_paid') {
            policyType = PolicyType.TermsPaid;
          } else if (policyTypeV1 === 'operation_policy') {
            policyType = PolicyType.Operation;
          } else if (policyTypeV1 === 'personal_information') {
            policyType = PolicyType.PersonalInformation;
          } else if (policyTypeV1 === 'marketing_night') {
            policyType = PolicyType.MarketingNight;
          } else if (policyTypeV1 === 'use_personal_info') {
            policyType = PolicyType.UsePersonalInfo;
          } else if (policyTypeV1 === 'personal_ad') {
            policyType = PolicyType.PersonalAd;
          } else if (policyTypeV1 === 'payment_service') {
            policyType = PolicyType.PaymentService;
          } else if (policyTypeV1 === 'privacy_safe') {
            policyType = PolicyType.PrivacySafe;
          } else if (policyTypeV1 === 'marketing_third') {
            policyType = PolicyType.MarketingThird;
          } else {
            policyType = policyTypeV1 as PolicyType;
          }
          path = `/policy/${policyType}`;
          queryparam = rest;
        }
      }
      break;
    case 'home':
      {
        const {series_id, seriesId, seriesid, ...rest} = parsedQueryparam;
        // @ts-ignore
        const seriesTitle =
          splittedPathList.length > 2 ? splittedPathList[1] : '';
        // @ts-ignore
        const _seriesId =
          splittedPathList.length > 2
            ? splittedPathList[2]
            : (series_id ?? seriesid ?? seriesId);

        if (!_seriesId) {
          path = '/';
        }
        path = `/content/${_seriesId}`;
        queryparam = rest;
      }
      break;
    case 'link':
      {
        if (splittedPathList.length > 1) {
          const linkType = splittedPathList[1];
          switch (linkType) {
            // link/redeem/:code, link/redeem
            case 'redeem':
              {
                path = '/redeem';
                const referrer = {
                  utm_source: 'link',
                  utm_medium: 'googleplay',
                  utm_campaign: 'redeem',
                };
                queryparam = {
                  ...parsedQueryparam,
                  ...referrer,
                  ...(splittedPathList[2] && {code: splittedPathList[2]}),
                };
              }
              break;
            case 'to':
              // link/to/:pageKey
              {
                const pageKey = splittedPathList[2];
                switch (pageKey) {
                  case 'redeem':
                  case 'link-redeem':
                    {
                      const {code, ...rest} = parsedQueryparam;
                      path = '/redeem';
                      const referrer = {
                        utm_source: 'link',
                        utm_medium: 'googleplay',
                        utm_campaign: 'redeem',
                      };
                      queryparam = {
                        ...rest,
                        ...referrer,
                        ...(code && {code}),
                      };
                    }
                    break;
                  default:
                    // /link/to/:pagekey 는 v2 에서도 지원하는 API 이므로 express 에서 별도 처리합니다
                    break;
                }
              }
              break;
            case 'app':
              {
                if (splittedPathList.length < 3) {
                  return;
                }
                const linkAppType = splittedPathList[2];
                switch (linkAppType) {
                  // link/app/event/:eventId
                  case 'event':
                    {
                      const eventId = splittedPathList[3];
                      origin = linkOrigin;
                      path = 'open/webview/event';
                      queryparam = {
                        ...parsedQueryparam,
                        hash_uid: eventId,
                      };
                    }
                    break;
                  /** @deprecated */
                  // link/app/special-gift/:giftId/:auid
                  case 'special-gift':
                    {
                      const giftId = splittedPathList[3];
                      const auid = splittedPathList[4];
                      origin = linkOrigin;
                      path = 'open/webview/special-gift';
                      queryparam = {
                        ...parsedQueryparam,
                        gift_id: giftId,
                        auid,
                      };
                    }
                    break;
                  // link/app/:seriesIdOrMain
                  default:
                    {
                      const seriesIdOrMain = splittedPathList[2];
                      if (!seriesIdOrMain || seriesIdOrMain === 'main') {
                        path = '/';
                        queryparam = {
                          ...parsedQueryparam,
                        };
                      } else {
                        origin = linkOrigin;
                        path = 'open/content';
                        queryparam = {
                          ...parsedQueryparam,
                          series_id: seriesIdOrMain,
                        };
                      }
                    }
                    break;
                }
              }
              break;
            default:
              {
                // link/:seriesId
                const seriesIdPath = splittedPathList[1];
                const {page_id, seriesid, ...rest} = parsedQueryparam;
                const productId = page_id;
                const seriesId = seriesIdPath ?? seriesid;
                if (productId && seriesId) {
                  path = `/content/${seriesId}/viewer/${productId}`;
                } else if (seriesId) {
                  path = `/content/${seriesId}`;
                } else {
                  // express 단에서 seriesId 도출하는 플로우 진행합니다
                  break;
                }
                queryparam = rest;
              }
              break;
          }
        } else {
          // link
          path = '/';
          queryparam = parsedQueryparam;
        }
      }
      break;
    case 'main':
      {
        if (splittedPathList.length > 1) {
          switch (splittedPathList[1]) {
            case 'recommend-events':
              {
                path = '/landing/event';
                queryparam = parsedQueryparam;
              }
              break;
          }
        } else {
          path = '/';
          queryparam = parsedQueryparam;
        }
      }
      break;
    // viewer/:seriesTitle/:viewerTitle/:productId(\d+)
    // viewer/:viewerTitle/:productId(\\d+)'
    case 'viewer':
      {
        const {
          series_id,
          seriesid,
          seriesId,
          product_id,
          productid,
          productId,
          ...rest
        } = parsedQueryparam;
        // @ts-ignore
        const seriesTitle =
          splittedPathList.length > 3 ? splittedPathList[1] : '';
        // @ts-ignore
        const viewerTitle =
          splittedPathList.length > 3
            ? splittedPathList[2]
            : splittedPathList[1];
        const _productId =
          (splittedPathList.length > 3
            ? splittedPathList[3]
            : splittedPathList[2]) ??
          product_id ??
          productId ??
          productid;
        const _seriesId = series_id ?? seriesid ?? seriesId;
        if (_productId && _seriesId) {
          path = `/content/${_seriesId}/viewer/${_productId}`;
        } else if (_productId) {
          // express 단에서 seriesId 도출하는 플로우 진행합니다
          path = `/viewer/${_productId}`;
        } else {
          break;
        }
        queryparam = rest;
      }
      break;
    case 'store':
      {
        switch (splittedPathList[1]) {
          case 'charging_history':
            {
              path = '/history/cash';
              queryparam = parsedQueryparam;
            }
            break;
          case 'coupon_history':
            {
              path = '/history/ticket';
              queryparam = parsedQueryparam;
            }
            break;
          case 'coupon_register':
            {
              path = '/redeem';
              queryparam = parsedQueryparam;
            }
            break;
          case 'gateway':
            {
              const {t_ch, ...rest} = parsedQueryparam;
              path = '/';
              queryparam = {...rest, ...(t_ch && {t_ch})};
            }
            break;
          // store/event/v2/{hashedeventid}
          // store/event/v3/{hashedeventid}
          case 'event':
            {
              const hashedeventid = splittedPathList[3];
              path = `/event/${hashedeventid}`;
              queryparam = parsedQueryparam;
            }
            break;
        }
      }
      break;
    // reward/gotcha?id=gotcha_id
    case 'reward':
      {
        const {id, ad_loc_id, ...rest} = parsedQueryparam;
        path = '/gacha';
        queryparam = {
          ...rest,
          ...(ad_loc_id && {ad_loc_id}),
          ...(id && {gacha_uid: id}),
        };
      }
      break;
  }

  if (!path) {
    return;
  }

  return new PagewebUrl({origin, path, queryparam});
}
